import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Log authentication state for debugging
  useEffect(() => {
    console.log('Protected route auth state:', { 
      user: user ? 'authenticated' : 'not authenticated', 
      loading, 
      path: location.pathname 
    });
  }, [user, loading, location]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    console.log('User not authenticated, redirecting to auth page');
    // Redirect to auth page, but save the location they were trying to access
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  console.log('User is authenticated, rendering protected content');
  return <>{children}</>;
};

export default ProtectedRoute;